import { render, staticRenderFns } from "./OrderCusBookDetail.vue?vue&type=template&id=6efa380d"
import script from "./OrderCusBookDetail.vue?vue&type=script&lang=js"
export * from "./OrderCusBookDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports